import React, { Component, cloneElement } from 'react';
import { Button, ButtonGroup } from 'ui';

class EditForm extends Component {
  state = {
    workspace: this.props.workspace,
  };

  static Submit = props => <Button customColor submit {...props} />;

  static Cancel = props => (
    <button type="button" className="u-linkBtn mr-16" {...props}>
      {t('common.cancel')}
    </button>
  );

  static defaultProps = {
    workspace: {
      name: '',
    },
  };

  componentDidMount() {
    this.nameInputRef.select();
    this.nameInputRef.focus();
  }

  handleInputChange = e => {
    const { name, value } = e.target;
    this.setState(({ workspace }) => ({
      workspace: { ...workspace, [name]: value },
    }));
  };

  handleSubmit = e => {
    e.preventDefault();
    const { workspace } = this.state;
    this.props.onSubmit({
      ...workspace,
      name: workspace.name.trim(),
    });
  };

  renderButtons() {
    const { children, loading } = this.props;
    const { workspace } = this.state;
    return React.Children.map(children, child => {
      if (child.type === EditForm.Submit) {
        return cloneElement(child, {
          disabled: !workspace.name.trim(),
          loading,
        });
      }
      if (child.type === EditForm.Cancel) {
        this.cancelButtonInstance = child;
        return cloneElement(child, {
          disabled: loading,
        });
      }
      return null;
    });
  }

  render() {
    const { error } = this.props;
    const { name } = this.state.workspace;
    return (
      <form className="w-fill" onSubmit={this.handleSubmit}>
        {error && (
          <div className="ErrorContainer Animated Animated--fadeIn">
            {error.error_message}
          </div>
        )}
        <fieldset className="mb-8">
          <label htmlFor="workspace-name">
            {t('workspaces.workspace_name')}
          </label>
          <input
            ref={n => {
              this.nameInputRef = n;
            }}
            autoComplete="off"
            className="NewInput NewInput--light NewInput--fw"
            id="workspace-name"
            name="name"
            onChange={this.handleInputChange}
            value={name}
          />
        </fieldset>
        <ButtonGroup alignEnd>{this.renderButtons()}</ButtonGroup>
      </form>
    );
  }
}

export default EditForm;
